module.exports = __webpack_public_path__ + "static/media/winSmall90_1.3e886354.svg";